// import { gql, useFragment } from "@apollo/client";

// Components
import Container from "@/components-layout/container/container";

export default function PostContent({ content }) {
  // Use Fragment
  // const { complete, data } = useFragment({
  //   fragment: PostContent.fragments.entry,
  //   fragmentName: "Gutenberg",
  //   from: {
  //     __typename: content.__typename,
  //     id: content.id,
  //   },
  // });
  // if (!complete) {
  //   return;
  // }

  return (
    <section className="wpContent">
      <Container>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </Container>
    </section>
  );
}

// HeaderTopNav.fragments = {
//   entry: gql`
//     fragment Gutenberg on Page {
//       content
//       editorBlocks {
//         name
//         ... on GravityformsForm {
//           attributes {
//             form {
//               title
//               databaseId
//               formFields {
//                 nodes {
//                   databaseId
//                   type
//                   ... on TextField {
//                     label
//                     description
//                   }
//                 }
//               }
//             }
//           }
//         }
//       }
//     }
//   `,
// };
